
import React, { Component } from 'react';
import shortID from 'short-id-gen';
import moment from 'moment';
import { Button, InputGroup, Intent } from '@blueprintjs/core';
import { Row, Column as Col } from 'hedron';

import Modal from './Modal';
import Select from '../form/Select';
import SelectWeek from '../form/SelectWeek';
import SelectTime from '../form/SelectTime';

function checkConflictBetweenTimePeriods(startA, endA, startB, endB) {
  return (
    startB.isBetween(startA, endA)
    || endB.isBetween(startA, endA)
    || startA.isBetween(startB, endB)
  );
}

const initialState = {
  startDay: null,
  startHour: null,
  startMinute: null,
  endDay: null,
  endHour: null,
  endMinute: null,
  playlist: null,
  inputError: {},
  createdAt: null,
  lastModified: null,
}

class SheduleEntryModal extends Modal {

  constructor(props) {
    super(props);

    this.state = { ...initialState };

    this.remove = this.remove.bind(this);
    this.validateInputs = this.validateInputs.bind(this);

    this.title = "Shedule Eintrag";
    this.initialState = initialState;
  }

  remove() {
    const { customerID, entryID } = this.props;
    if (!customerID || !entryID || entryID === 'new') return this.hide();

    this.props.database.ref(`/customers/${customerID}/shedule/${entryID}`).remove();
    this.hide();
  }

  validateInputs() {
    const { startDay, startHour, startMinute, endDay, endHour, endMinute, playlist } = this.state;
    if (typeof startDay !== 'number' || startDay < 0 || startDay > 6) {
      this.setState({ inputError: { field: 'startDay' } });
      return false;
    }
    if (typeof startHour !== 'number' || startHour < 0 || startHour > 24) {
      this.setState({ inputError: { field: 'startTime' } });
      return false;
    }
    if (typeof startMinute !== 'number' || startMinute < 0 || startMinute > 60 || (startHour === 24 && startMinute !== 0)) {
      this.setState({ inputError: { field: 'startTime' } });
      return false;
    }
    if (typeof endDay !== 'number' || endDay < 0 || endDay > 6) {
      this.setState({ inputError: { field: 'endDay' } });
      return false;
    }
    if (typeof endHour !== 'number' || endHour < 0 || endHour > 24) {
      this.setState({ inputError: { field: 'endTime' } });
      return false;
    }
    if (typeof endMinute !== 'number' || endMinute < 0 || endMinute > 60 || (endHour === 24 && endMinute !== 0)) {
      this.setState({ inputError: { field: 'endTime' } });
      return false;
    }
    if (typeof playlist !== 'string' || !this.props.availablePlaylists[playlist]) {
      this.setState({ inputError: { field: 'playlist' } });
      return false;
    }

    const start = moment().day(startDay).hour(startHour).minute(startMinute).endOf('minute');
    const end = moment().day(endDay).hour(endHour).minute(endMinute).startOf('minute');

    if (startDay === endDay && end.isBefore(start)) {
      this.setState({ inputError: { fieldID: 'formSheduleEntryEndDay', text: 'Ende kann nicht am selben Tag und vor dem Start sein.'} });
      return false;
    }

    if (end.isBefore(start)) end.add(1, 'week');

    if (end.diff(start, 'minutes') < 5) {
      this.setState({ inputError: { text: 'Die minimale Dauer beträgt 5 Minuten' }});
      return false;
    }

    for (let key in this.props.entries) {
      if (!this.props.entries.hasOwnProperty(key)) continue;
      if (key === this.props.entryID) continue;

      const sheduleEntry = this.props.entries[key];
      const sheduleEntryStart = moment().day(sheduleEntry.startDay).hour(sheduleEntry.startHour).minute(sheduleEntry.startMinute).endOf('minute');
      const sheduleEntryEnd = moment().day(sheduleEntry.endDay).hour(sheduleEntry.endHour).minute(sheduleEntry.endMinute).startOf('minute');
      if (sheduleEntryEnd.isBefore(sheduleEntryStart)) sheduleEntryEnd.add(1, 'week');

      if (checkConflictBetweenTimePeriods(start, end, sheduleEntryStart, sheduleEntryEnd)) {
        this.setState({ inputError: { text: 'Diese Zeiten stehen im Konflikt mit einem anderen Eintrag.' } })
        return false;
      }
    }

    this.setState({ inputError: {} });
    return true;
  }

  save() {
    const { customerID, entryID } = this.props;
    if (!customerID || !entryID) return;
    if (!this.validateInputs()) return;

    const id = entryID === 'new' ? shortID.generate(10) : entryID;

    this.props.database.ref(`/customers/${customerID}/shedule/${id}`).set({
      startDay: this.state.startDay,
      startHour: this.state.startHour,
      startMinute: this.state.startMinute,
      endDay: this.state.endDay,
      endHour: this.state.endHour,
      endMinute: this.state.endMinute,
      playlist: this.state.playlist,
      createdAt: this.state.createdAt || new Date(),
      lastModified: new Date(),
    })
    this.hide();
  }

  componentWillReceiveProps(newProps) {
    if ((newProps.sheduleEntryID !== this.props.sheduleEntryID || newProps.entry !== this.props.entry) && newProps.entry) {
      this.setState({ ...initialState, ...newProps.entry });
    }
  }

  getPlaylistOptions() {
    const playlists = [
      <option key="default" value="">Playlist zum Hinzufügen wählen</option>
    ];
    for (let key in this.props.availablePlaylists) {
      if (!this.props.availablePlaylists.hasOwnProperty(key)) continue;
      const playlist = this.props.availablePlaylists[key];
      playlists.push(
        <option key={key} value={key}>{playlist.name}</option>
      );
    }
    return playlists;
  }

  renderActions() {
    return (
      <Button intent={Intent.DANGER} onClick={this.remove}>Löschen</Button>
    );
  }

  renderBody() {
    return (
      <Row>
        <Col sm={12}>
          <strong>Beginn</strong>
        </Col>
        <SelectWeek
          label="Tag"
          sm={12}
          controlId="formScheduleEntryStartDay"
          validationState={this.state.inputError.field === 'startDay' ? 'error' : null}
          placeholder="Tag wählen"
          value={typeof this.state.startDay === 'number' ? this.state.startDay : ''}
          onChange={(e) => this.setState({ startDay: Number(e.target.value) })}
        />
        <SelectTime
          label="Beginn"
          sm={12}
          controlId="formSheduleEntryStart"
          validationState={this.state.inputError.field === 'startTime' ? 'error' : null}
          value={{ hour: this.state.startHour, minute: this.state.startMinute }}
          onChange={(time) => this.setState({ startHour: time.hour, startMinute: time.minute })}
        />
        <Col sm={12}>
          <strong>Ende</strong>
        </Col>
        <SelectWeek
          label="Tag"
          sm={12}
          controlId="formScheduleEntryEndDay"
          validationState={this.state.inputError.field === 'endDay' ? 'error' : null}
          placeholder="Tag wählen"
          value={typeof this.state.endDay === 'number' ? this.state.endDay : ''}
          onChange={(e) => this.setState({ endDay: Number(e.target.value) })}
        />
        <SelectTime
          label="Ende"
          sm={12}
          controlId="formSheduleEntryEndTime"
          validationState={this.state.inputError.field === 'endTime' ? 'error' : null}
          value={{ hour: this.state.endHour, minute: this.state.endMinute }}
          onChange={(time) => this.setState({ endHour: time.hour, endMinute: time.minute })}
        />
        <Col sm={12}>
          <strong>Playlist</strong>
        </Col>
        <div className="pt-select">
          <select
            sm={12}
            controlId="formSheduleEntryPlaylist"
            validationState={this.state.inputError.field === 'playlist' ? 'error' : null}
            value={this.state.playlist || ''}
            onChange={(e) => this.setState({ playlist: e.target.value })}
          >
            {this.getPlaylistOptions()}
          </select>
        </div>
      </Row>
    );
  }
}

export default SheduleEntryModal;



/** WEBPACK FOOTER **
 ** ./src/modals/SheduleEntryModal.js
 **/